export default __webpack_public_path__ + "static/media/arrow.1472e3f7.svg";